import { CreateParams, GetListParams, GetOneParams, UpdateParams } from 'react-admin';
import axiosApiInstance, { postRequestCacheConfig } from '../../axiosConfig';
import { Resource } from 'src/constants';
import { getRidOfServiceKeys, updateEmployeeCenters } from 'src/api/helpers';

const transformCentersData = (params: CreateParams | UpdateParams) => {
    return params.data.employeeCenters.map((center: any) => {
        const dateOfStarting = center.dateOfStarting ? center.dateOfStarting : center.dateOfStartingCLNC;
        // Grab roles from original roles or CLNC
        const rolesFromForm = center.roles && center.roles.length !== 0 ? center.roles : center.rolesCLNC;
        // As a temporary fix, we need to transform single string value into array with one value, as UI changed multiselect dropdown to single select
        // TODO: This should be removed after backend could change the contract to handle ONE string value for roles
        const roles = [];
        if (Array.isArray(rolesFromForm) && rolesFromForm.length) {
            roles.push(...rolesFromForm);
        } else if (typeof rolesFromForm === 'string') {
            roles.push(rolesFromForm);
        }

        const rate = center.rate ? center.rate : undefined;
        return { ...center, dateOfStarting, roles, rate, dateOfStartingCLNC: undefined, rolesCLNC: undefined };
    });
};

export default {
    getList: async (params: GetListParams) => {
        let { keyword, employmentType, centersInvolvementFilter, ...filters } = params.filter;

        filters = {
            ...filters,
            ...(employmentType === 'STAFF'
                ? { isStaff: true }
                : employmentType === 'CONTRACT'
                  ? { isContract: true }
                  : {})
        };

        if (centersInvolvementFilter) {
            filters = {
                ...filters,
                ...(centersInvolvementFilter === 1 ? { centersInvolvementLess: 1 } : { centersInvolvementGreater: 2 })
            };
        }

        filters = Object.keys(filters).length ? filters : undefined;
        const pageRequest = {
            page: params.pagination.page - 1,
            size: params.pagination.perPage,
            sort: params.sort && { properties: [params.sort.field], direction: params.sort.order },
            keyword,
            filters,
            _timestamp: Date.now()
        };

        const response = await axiosApiInstance.post('employees', pageRequest, {
            ...postRequestCacheConfig,
            headers: {
                ...postRequestCacheConfig.headers,
                'Cache-Control': 'no-cache'
            }
        });

        return {
            data: response.data.content,
            total: response.data.totalElements
        };
    },

    create: (params: CreateParams) => {
        const payload = params.data;
        getRidOfServiceKeys(payload);
        const employeeCenters = transformCentersData(params);

        return axiosApiInstance.post(`employees/add`, { ...payload, employeeCenters }).then((response) => response);
    },

    update: (params: UpdateParams) => {
        const payload = params.data;
        getRidOfServiceKeys(payload);
        const employeeCenters = transformCentersData(params);

        return axiosApiInstance.put(`employees/update`, { ...payload, employeeCenters }).then((response) => response);
    },

    getOne: (params: GetOneParams) => {
        return axiosApiInstance.get(`${Resource.EMPLOYEES}/${params.id}`).then((response) => {
            // as backend will not transform classes into levels - making it happen on a UI side
            const mappedEmployeeCenters = updateEmployeeCenters(response.data.employeeCenters);

            return { ...response, data: { ...response.data, employeeCenters: mappedEmployeeCenters } };
        });
    }
};
